<template>
	<BasePublishCategory v-slot="{item: category}" :seo="true">
		<BasePublishPosts v-slot="{items: posts, nextPage, loadMore, loading}">
			<CmsPageHeader class="p-header" :class="{'no-posts': !posts?.length}">
				<CmsBreadcrumbs v-if="category?.breadcrumbs?.length" :items="category.breadcrumbs" />
				<h1>{{category.seo_h1}}</h1>
			</CmsPageHeader>

			<div class="wrapper">
				<div class="p-items" v-if="posts?.length">
					<PublishIndexEntry v-for="(post, index) in posts" :key="post.id" :item="post" :class="{'pp-featured': index == 0 && !mobileBreakpoint}" />
				</div>
				<div v-else class="p-empty"><BaseCmsLabel code="no_publish" /></div>
				<ClientOnly>
					<div class="load-more-container" v-if="nextPage" data-posts-scroll-trigger>
						<button type="button" class="btn noarrow load-more btn-load-more" :class="{'loading': loading}" @click="loadMore"><UiLoader v-if="loading" size="small" color="white" /><BaseCmsLabel code="load_more_articles" /></button>
					</div>
				</ClientOnly>
				<BaseUiPagination class="pagination" />
			</div>
		</BasePublishPosts>
	</BasePublishCategory>
</template>

<script setup>
	const {mobileBreakpoint} = inject('rwd');
</script>

<style lang="less" scoped>
	.p-items{
		display: flex; flex-wrap: wrap; gap: 64px; position: relative; z-index: 1; margin-top: -220px; padding-bottom: 70px;
		@media (max-width: @l){gap: 30px; row-gap: 40px; padding-bottom: 40px;}
		@media (max-width: @m){margin-top: 0; row-gap: 30px; flex-flow: column; padding-bottom: 32px;}
	}
	.p-header{
		text-align: center; padding-bottom: 230px; background-position: center 80%;
		:deep(h1){max-width: none;}
		:deep(.bc){justify-content: center;}
		&.no-posts{padding-bottom: 0;}
		@media (max-width: @m){padding-bottom: 4px;}
	}
	.p-empty{
		text-align: center; padding: 70px 0;
		@media (max-width: @t){padding: 40px 0;}
		@media (max-width: @m){padding: 0 0 32px;}	
	}
	.load-more-container{
		text-align: center; padding: 0 0 70px;
		@media (max-width: @m){padding-bottom: 32px;}	
	}
	.btn-load-more{
		padding-inline: 40px;
		@media (max-width: @m){width: auto; padding-inline: 32px}
	}
	</style>
